module.exports = __webpack_public_path__ + "assets/82dded9ecbb30b6977d33a2326cf451e.wav";